
import {
    addToChainAfter,
} from "@insite/client-framework/HandlerCreator";
import { chain, DispatchSetNavDrawerIsOpen } from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";



addToChainAfter(chain, DispatchSetNavDrawerIsOpen, props => {

    if (props.parameter.navDrawerIsOpen === true) {
        props.dispatch({
            type: "Components/DesktopDrawer/SetDesktopNavDrawerIsOpen",
            navDrawerIsOpen: false,
        } as any);
    }
});